import { catchError, EMPTY, firstValueFrom, map } from 'rxjs';
import { Community, Coords } from '../../../swagger-api';
import { MapFilters } from '../map.enum';
import { MapItemDetailsProvider } from './map-item-details.provider';

export class MapCommunityDetailsProvider extends MapItemDetailsProvider {
  readonly filter = MapFilters.COMMUNITIES;

  async fetchLocationForItemById(id: string): Promise<Coords> {
    return await firstValueFrom(
      this.apiService.restSocialCommunitiesGet(id).pipe(
        map((community: Community) => community.location.center),
        catchError(() => EMPTY),
      ),
    );
  }

  getMarkerIdByEntityId(id: string): string {
    return id;
  }
}
